import styles from './PlanCardPrice.module.scss';
import { getTotalRecurringPriceLabel } from 'src/utils';
import { CanonicalInterval, PlanFamily, SubscriptionPlanInfo } from 'src/types';
import { PlanCardDiscountLabel } from 'src/pages/PaymentBetaPage/componentsV2/PlanCardDiscountLabel';

export interface PlanCardPriceProps {
  sectionPlan: SubscriptionPlanInfo;
}

export const PlanCardPrice = ({ sectionPlan }: PlanCardPriceProps) => {
  const { plan_family, recurring_discount_amount, period } = sectionPlan;

  const isTeams = plan_family === PlanFamily.BUSINESS;

  const finalPriceLabel = getTotalRecurringPriceLabel({
    displayedPlan: sectionPlan,
  });

  return (
    <div className={styles.root}>
      <p className={styles.priceContainer}>
        <span className={styles.currentPrice}>
          <span className={styles.currentPriceTitle}>${finalPriceLabel}</span>

          <span className={styles.currentPriceSubtitle}>
            <span>{isTeams ? 'per seat ' : ''}/mo</span>
          </span>
        </span>
        {period === CanonicalInterval.ANNUALLY && (
          <span className={styles.billedAnnually}>billed yearly</span>
        )}
      </p>

      {!!recurring_discount_amount && (
        <PlanCardDiscountLabel discountAmount={recurring_discount_amount} />
      )}
    </div>
  );
};
